var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMinusInCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.3686 16 16 12.3765 16 8C16 3.63137 12.3608 0 7.99216 0C3.61569 0 0 3.63137 0 8C0 12.3765 3.62353 16 8 16ZM8 14.6667C4.29804 14.6667 1.34118 11.702 1.34118 8C1.34118 4.30588 4.2902 1.33333 7.99216 1.33333C11.6863 1.33333 14.6588 4.30588 14.6667 8C14.6745 11.702 11.6941 14.6667 8 14.6667ZM4.83922 8.66667C4.4 8.66667 4.08627 8.43922 4.08627 8.02353C4.08627 7.6 4.38431 7.35686 4.83922 7.35686H11.1451C11.6078 7.35686 11.8902 7.6 11.8902 8.02353C11.8902 8.43922 11.5843 8.66667 11.1451 8.66667H4.83922Z",
    fill: "#FF2D55"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMinusInCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MinusInCircle.676b1d1310a415d6f38c34c3a6766d1d.svg";